// Reusable option lists for the lead capture flow.
export const PROJECT_TYPES = [
  "Custom Software Development",
  "SaaS Product Development",
  "Mobile Application",
  "Enterprise Application",
  "AI & Automation Solutions",
  "ERP & Business Process Automation",
  "Cloud Engineering",
  "Product Engineering",
  "UI / UX Design",
  "Digital Transformation Consulting",
  "Other",
];

export const BUDGET_RANGES = [
  "Under $10K",
  "$10K – $25K",
  "$25K – $50K",
  "$50K – $100K",
  "$100K – $250K",
  "$250K+",
  "Not sure yet",
];

// Curated country list — Zolvix's primary markets first, then alphabetical for the rest.
export const COUNTRIES = [
  "India",
  "United Arab Emirates",
  "Saudi Arabia",
  "Qatar",
  "Kuwait",
  "Bahrain",
  "Oman",
  "United States",
  "United Kingdom",
  "Canada",
  "Australia",
  "Singapore",
  "Germany",
  "France",
  "Netherlands",
  "Switzerland",
  "Spain",
  "Italy",
  "Ireland",
  "Sweden",
  "Norway",
  "Denmark",
  "South Africa",
  "Kenya",
  "Nigeria",
  "Japan",
  "South Korea",
  "Hong Kong",
  "Malaysia",
  "Indonesia",
  "Philippines",
  "Thailand",
  "Vietnam",
  "Bangladesh",
  "Sri Lanka",
  "Pakistan",
  "Nepal",
  "Other",
];
